import { render, staticRenderFns } from "./newLc.vue?vue&type=template&id=12e93e2d&scoped=true"
import script from "./newLc.vue?vue&type=script&lang=js"
export * from "./newLc.vue?vue&type=script&lang=js"
import style0 from "./newLc.vue?vue&type=style&index=0&id=12e93e2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e93e2d",
  null
  
)

export default component.exports